<template>
    <el-container class="page-x" direction="vertical">
        <div class="search-x">
            <div class="search-item">
                <span class="label">省</span>
                <el-select v-model="searchBox.province" @change="changeProvince" clearable placeholder="请选择省">
                    <el-option
                        v-for="item in provinceList"
                        :key="item.id"
                        :label="item.name"
                        :value="item.name">
                    </el-option>
                </el-select>
            </div>
            <div class="search-item">
                <span class="label">市</span>
                <el-select v-model="searchBox.city" clearable placeholder="请选择市">
                    <el-option
                        v-for="item in cityList"
                        :key="item.id"
                        :label="item.name"
                        :value="item.name">
                    </el-option>
                </el-select>
            </div>
            <div class="search-item">
                <span class="label">区/县</span>
                <el-input class="input-box" placeholder="请输入区/县" clearable v-model="searchBox.area"></el-input>
            </div>
            <el-button v-auth="'sa_area_view'" type="primary" class="search-btn" @click="search">查询</el-button>
            <el-button class="search-btn" v-auth="'sa_area_edit'" type="primary" @click="() => $root.showPage = false">重置</el-button>
            <el-button v-auth="'sa_area_create'"  type="warning" class="search-btn" @click="toAdd(null, 1)">添加</el-button>
            <el-button v-auth="'sa_area_export'"  type="warning" class="search-btn" @click="exportArea">导出</el-button>
        </div>
        <div class="table-x" ref="tableBox">
            <el-table v-loading="loading"
                      :data="tableData"
                      :height="tableHeight"
                      border
                      class="mb10">
                <el-table-column prop="province"
                                 align="center"
                                 label="省"
                                 min-width="100">
                </el-table-column>
                <el-table-column prop="city"
                                 align="center"
                                 label="市"
                                 min-width="100">
                </el-table-column>
                <el-table-column prop="area"
                                 align="center"
                                 label="区/县"
                                 min-width="100">
                </el-table-column>
                <el-table-column label="操作"
                                 min-width="300"
                                 align="center">
                    <template slot-scope="scope">
                        <el-button-group>
                            <el-button v-auth="'sa_area_delete'" type="text" size="small" class="table-btn" @click="delIsExistWebiste(scope.row)">删除</el-button>
                            <el-button v-auth="'sa_area_update'" type="text" size="small" class="table-btn" @click="toAdd(scope.row)" v-if="scope.row.sourceType !==1">修改</el-button>
                        </el-button-group>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <!-- 分页部分 -->
        <div class="pagination mb20">
            <el-pagination
                @current-change="handleCurrentChange"
                :current-page="searchBox.pageNo"
                @size-change="handleSizeChange"
                :page-sizes="[10,50,100]"
                :page-size="searchBox.pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total"
                background
            > 
            </el-pagination>
        </div>
        <!-- 添加、修改弹层 -->
        <el-dialog
                append-to-body
                :title="dialogTitle"
                :visible.sync="dialogVisible"
                @close="closeDialog"
                class="edit-dialog-area"
                left
                :close-on-click-modal="false">
            <el-form ref="form" :model="formData" :rules="formRules" label-width="80px">
                <el-form-item label="省" prop="province">
                    <el-select v-model="formData.province" :disabled="isEdit" @change="changeProvince" clearable placeholder="请选择省">
                        <el-option
                            v-for="item in provinceList"
                            :key="item.id"
                            :label="item.name"
                            :value="item.name">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="市" prop="city">
                    <el-select v-model="formData.city" :disabled="isEdit" @change="changeCity" clearable placeholder="请选择市">
                        <el-option
                            v-for="item in cityList"
                            :key="item.id"
                            :label="item.name"
                            :value="item.name">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="区/县" prop="area">
                    <el-input v-model.trim="formData.area" placeholder="请输入区/县" maxlength="50" clearable></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer" >
                <el-button @click="dialogVisible = false" >退出</el-button>
                <el-button type="primary" @click="addArea" :loading="submitLoading" >确定</el-button>
            </span>
        </el-dialog>
    </el-container>
</template>

<script>
    import { mapGetters } from "vuex";
    import { dateFormat } from "@/assets/js/until.js";
    export default {
        data() {
            return {
                searchBox: {
                    province: '',
                    city: '',
                    area: '',
                    pageNo: 1,
                    pageSize: 10
                },
                loading: false,
                tableHeight: 0,
                tableData: [],
                total: 0,
                dialogVisible: false,
                dialogTitle: '',
                formData: {
                    province: '',
                    city: '',
                    area: '',
                },
                formRules: {
                    province: { required: true, message: '请选择省', trigger: 'change'},
                    city: { required: true, message: '请选择市', trigger: 'change'},
                    area: { required: true, message: '请输入区/县', trigger: 'blur'},
                },
                isEdit: false,
                dialogLoading: false,
                submitLoading: false,
                cityList: [],
                provinceList: [],
                itemRow: {} // 省市区详情
            }
        },
        created(){
            this.$root.breadList = [
                {name: '系统管理', link: ''},
                {name: '行政区划管理', link: ''},
            ]
        },
        mounted() {
            this.$nextTick(() => {
                this.listenWindow()
                this.getData();
                this.getAreaProvince()
            });
        },
        computed:{
            ...mapGetters(["userName"]),
        },
        methods: {
            //窗口改变，重新取得高度
            listenWindow() {
                this.tableHeight = this.$refs.tableBox.offsetHeight;
                window.addEventListener('resize', ()=>{
                    clearTimeout(this.resizeFlag)
                    this.resizeFlag = setTimeout(() => {
                        try {
                            this.tableHeight = this.$refs.tableBox.offsetHeight;
                        } catch (error) {}
                    }, 300);
                })
            },
            changeProvince(province) {
                if(province) this.getAreaCity(province)
                else this.cityList = []
                let findItem = this.provinceList.find((o) => o.name === province)
                this.formData.provinceId = findItem.id
            }, 
            changeCity(city) {
                let findItem = this.cityList.find((o) => o.name === city)
                this.formData.cityId = findItem.id
                console.log(this.formData)
            },
            /**
             * 获取省级地址列表
             */
            getAreaProvince() {
                this.axios
                    .get(this.getApiUrl("areaProvince"))
                    .then((res) => {
                        if (res.code === 1) {
                            this.provinceList = res.data || [];
                        } else {
                            this.$message.warning(res.msg);
                        }
                    })
                    .catch((err) => {
                        console.log(err);
                    });
            },
            /**
             * 动态获取市区
             */
            getAreaCity(province) {
                this.axios
                    .get(this.getApiUrl("areaCity") + "?province=" + province)
                    .then((res) => {
                        if (res.code === 1) {
                            this.cityList = res.data || [];
                        } else {
                            this.$message.warning(res.msg);
                        }
                    })
                    .catch((err) => {
                        console.log(err);
                    });
            },
            search() {
                this.searchBox.pageNo = 1;
                this.getData();
            },
            getData(){
                this.loading = true;
                this.axios
                    .get(this.getApiUrl("getAreaList"), {
                        params: this.$root.optionProcess(this.searchBox),
                    })
                    .then((res) => {
                        this.loading = false;
                        if (res.code === 1) {
                            this.tableData = res.data.data || [];
                            this.total = res.data.total;
                        } else {
                            this.$message.warning(res.msg);
                        }
                    })
                    .catch((err) => {
                        this.loading = false;
                        console.log(err);
                    });
            },
            /**
             * 判断与现有是否重复
             */
            async isExist() {
                let res = await this.axios.get(this.getApiUrl("areaExist"), {
                    params: this.formData
                })
                if (res.code === 1) {
                    if(res.data.isExist) {
                        this.$message.warning('操作失败，行政区划已存在，请再次确认！');
                    }else{
                        this.$confirm(`请确认是否新建${this.formData.province}${this.formData.city}${this.formData.area}?`, '提示', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            type: 'warning'
                        }).then(() => {
                            this.editArea()
                        }).catch(() => {

                        })
                    }
                } else {
                    this.$message.warning(res.msg);
                }
            },
            handleCurrentChange (val){
                this.searchBox.pageNo = val;
                this.getData();
            },
            handleSizeChange(val) {
                this.searchBox.pageNo = 1;
                this.searchBox.pageSize = val;
                this.getData();
            },
            closeDialog() {
                this.formData = {
                    province: '',
                    area: '',
                    city: '',
                }
                this.$refs.form.resetFields();
            },
            // 添加、修改账号
            toAdd(row) {
                if(this.$refs['form']) {
                    this.$refs['form'].clearValidate();
                }
                if(row) {
                    this.dialogTitle = '修改行政区划';
                    this.isEdit = true;
                    this.itemRow = row
                    this.formData = JSON.parse(JSON.stringify(row))
                    this.getAreaCity(this.formData.province)
                }else {
                    this.dialogTitle = '添加行政区划';
                    this.isEdit = false;
                }
                this.dialogVisible = true;
            },
            // 新增 or 编辑账号
            addArea() {
                this.$refs['form'].validate((valid) => {
                    if (!valid) {
                        return false
                    }
                    let oldValue = JSON.stringify(this.itemRow)
                    let newValue = JSON.stringify(this.formData)
                    if(this.isEdit && oldValue != newValue) {
                        this.$confirm(`请确认是否将${this.itemRow.province}${this.itemRow.city}${this.itemRow.area}修改为${this.formData.province}${this.formData.city}${this.formData.area}?`, '提示', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            type: 'warning'
                        }).then(() => {
                            this.editArea()
                        }).catch(() => {

                        })
                    }else{
                        this.isExist()
                    }
                })
            },
            editArea() {
                this.submitLoading = true;
                let p = {
                    ...this.formData,
                }
                let url = this.isEdit ? this.getApiUrl('areaUpdate') : this.getApiUrl('areaAdd');
                this.axios
                    .post(url, p,{
                        toJSON: true,
                    })
                    .then(res => {
                        this.submitLoading = false;
                        if(res.code === 1) {
                            this.$message.success(this.isEdit ? "已成功修改，谢谢！" : "已新建成功，谢谢！");
                            this.dialogVisible = false;
                            this.search();
                        }else {
                            this.$message.error(res.msg);
                        }
                    })
                    .catch(err => {
                        this.submitLoading = false;
                        console.log(err)
                    })
            },
            /**
             * 判断该区下无有效服务网点
             */
            async delIsExistWebiste(row) {
                let res = await this.axios.get(this.getApiUrl("areaWebsiteExist"), {
                    params: {
                        areaId: row.areaId
                    }
                })
                if (res.code === 1) {
                    if(!res.data.isExist) {
                        this.$confirm(`请确认删除${row.province}${row.city}${row.area}?`, '提示', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            type: 'warning'
                        }).then(() => {
                            this.delArea(row)
                        }).catch(() => {

                        })
                    }else{
                        this.$alert(`该行政区划下还有启用中的服务网点，请再次确认！`, '提示',{
                            confirmButtonText: '取消',
                            callback: action => {
                            }
                        });
                    }
                } else {
                    this.$message.warning(res.msg);
                }
            },
            // 删除区域
            delArea(row) {
                this.axios
                    .post(this.getApiUrl('areaDelete'), {
                        areaId: row.areaId
                    },{
                        toJSON: true,
                    })
                    .then(res => {
                        if(res.code === 1) {
                            this.$message.success(`已删除${this.formData.province}${this.formData.city}${this.formData.area}，谢谢！`);
                            this.search()
                        }else {
                            this.$message.error(res.msg);
                        }
                    })
                    .catch(err => {
                        console.log(err)
                    })
            },
            // 导出行政区
            exportArea() {
                let urlPath = this.getApiUrl("areaExport")
                let date = dateFormat(new Date());
                let query = Object.assign(
                    {},
                    this.searchBox,
                )
                let param = this.$root.optionProcess(JSON.parse(JSON.stringify(query)))
                delete param.pageNo;
                delete param.pageSize;
                let fileName = `行政区划表${date.replace(/-/g,"").slice(0,8)}${this.userName}`
                this.$root.exportFile(urlPath,param,fileName)
            },
        }
    }
</script>

<style lang="scss" scoped type="text/scss">
    .edit-dialog-user{
        .el-dialog__body{
            padding: 20px 50px 0;
        }
    }
    .edit-dialog-area .el-input {
        width: 80%;
    } 
    .edit-dialog-area .el-select {
        width: 80%;
    } 
</style>